import * as _ from 'underscore';

import { ContentSubplaceCtrl, IContentSubplaceResolve } from '../controllers/ContentSubplaceCtrl';
import { DataAlertsCtrl } from '../controllers/DataAlertsCtrl';
import { IErrorStateParams } from '../controllers/ErrorCtrl';
import { ExtractTasksCtrl, IExtractTasksContext } from '../controllers/ExtractTasksCtrl';
import { RunFlowTasksCtrl } from '../controllers/RunFlowTasksCtrl';
import { SubscriptionsCtrl } from '../controllers/SubscriptionsCtrl';
import { Place } from '../models/IPlace';
import { ErrorState } from '../services/ErrorState';
import { ServerService } from '../services/ServerService';

export namespace SubplaceStateConfigHelper {

  export interface SubplaceStateFnArgs {
    name: string;
    customResolve?: _.Dictionary<any>;
    templateUrl?: string;
  }

  export function subplaceState(args: SubplaceStateFnArgs): ng.ui.IState {
    const { name, customResolve } = args;
    const templateUrl = args.templateUrl || 'contentSubplace.html';

    const resolve: IContentSubplaceResolve = {
      subplace: [ 'place', (place: Place) => place.subplace(name) ],
      shouldFetchDetails: () => (() => true) // Fetches details by default
    };

    return {
      url: '/' + name,
      templateUrl: templateUrl,
      controller: ContentSubplaceCtrl,
      resolve: _.extend(resolve, customResolve)
    };
  }

  const defaultResolveExtractTasksContext =
      [ 'ServerService', (ServerService: ServerService): IExtractTasksContext => {
        return {
          modifyExtractTasksPermission: ServerService.isSessionSiteOrServerAdmin(),
          createExtractTaskFn: undefined
        };
      } ];

  export function addDataAlertsState(
      $stateProvider: ng.ui.IStateProvider,
      parentName: string,
      stateData?: any) {

    $stateProvider
    .state(parentName + '.dataAlerts', {
      url: '/dataAlerts',
      templateUrl: 'dataGridSubplaceWithoutFilterPanel.html',
      resolve: {
        subplace: [ 'place', (place: Place) => place.subplace('dataAlerts') ]
      },
      controller: DataAlertsCtrl,
      onEnter: [ 'ErrorState', 'ServerService',
        function(errorState: ErrorState, serverService: ServerService) {
          if (!serverService.isDataAlertsEnabled()) {
            const alertsDisabledErrorState: IErrorStateParams = {
              detailsLocKey: 'dataAlertsNotEnabledMessage'
            };
            errorState.go(alertsDisabledErrorState);
          }
        }
      ],
      data: stateData
    });
  }

  export function addExtractTasksState(
      $stateProvider: ng.ui.IStateProvider,
      parentName: string,
      resolveExtractTasksContext?: any) {

    $stateProvider
    .state(parentName + '.extractTasks', {
      url: '/extractRefreshes',
      templateUrl: 'extractTasks.html',
      resolve: {
        subplace: [ 'place', (place: Place) => place.subplace('extractTasks') ],
        extractTasksContext: resolveExtractTasksContext || defaultResolveExtractTasksContext
      },
      controller: ExtractTasksCtrl
    });
  }

  export function addSubscriptionsState($stateProvider: ng.ui.IStateProvider, parentName: string) {
    $stateProvider
    .state(parentName + '.subscriptions', {
      url: '/subscriptions',
      templateUrl: 'dataGridSubplaceWithoutFilterPanel.html',
      resolve: {
        subplace: [ 'place', (place: Place) => place.subplace('subscriptions') ]
      },
      controller: SubscriptionsCtrl
    });
  }

  export function addRunFlowTasksState($stateProvider: ng.ui.IStateProvider, parentName: string) {
    $stateProvider
    .state(parentName + '.flows', {
      url: '/flows',
      templateUrl: 'dataGridSubplaceWithoutFilterPanel.html',
      resolve: {
        subplace: [ 'place', (place: Place) => place.subplace('runFlowTasks') ]
      },
      controller: RunFlowTasksCtrl
    });
  }

  export function addTaskSubstatesForSchedules($stateProvider: ng.ui.IStateProvider, parentName: string) {
    addExtractTasksState($stateProvider, parentName);
    addSubscriptionsState($stateProvider, parentName);
    addRunFlowTasksState($stateProvider, parentName);
  }
}
